import { PRIMARY_COLORS } from 'asterX-UI/colors.constant'

export default function Dot({
  color = PRIMARY_COLORS[700],
  cx = '4',
  cy = '4'
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="8"
      viewBox="0 0 8 8"
      fill="none"
    >
      <circle cx={cx} cy={cy} r="4" fill={color} />
    </svg>
  )
}
